import P2GConditionalImage from '../P2GConditionalImage';
import { P2GBox } from '@parcel2go/core-ui';

interface props {
  product: { ImageUrl?: string };
  style?: object;
  p?: number;
}
export const ProductImage: React.FC<props> = (props) => {
  return (
    <P2GBox bordered p={props.p == undefined ? 1 : props.p} textAlign="center">
      <P2GConditionalImage
        style={props.style || { maxWidth: '100px', maxHeight: '55px' }}
        src={props.product?.ImageUrl || '/theme/smartsend/providers/p2g.svg'}
        alt="Image"
      />
    </P2GBox>
  );
};
